import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react"
import { currentUrl } from "../../../url"

export const accountsApi = createApi({
  reducerPath: "accountsApi",
  tagTypes: ["Account"],
  refetchOnMountOrArgChange: true,
  baseQuery: fetchBaseQuery({
    baseUrl: currentUrl,
    prepareHeaders: (headers) => {
      const accessToken = localStorage.getItem("accessToken")
      if (accessToken) {
        const token = accessToken.startsWith("Bearer ")
          ? accessToken
          : `Bearer ${accessToken}`
        headers.set("Authorization", token)
        headers.set("Accept", "application/json")
        headers.set("Content-Type", "application/json")
      }
      return headers
    },
  }),
  endpoints: (build) => ({
    // GET /finance/accounts?page=1
    getAccounts: build.query({
      query: (params = {}) => {
        const { page = 1, per_page = 10 } = typeof params === 'number' ? { page: params } : params
        return `/master/finance/accounts?page=${page}&per_page=${per_page}`
      },
      providesTags: (result) =>
        result?.data
          ? [
              ...result.data.map(({ id }) => ({ type: "Account", id })),
              { type: "Account", id: "LIST" },
            ]
          : [{ type: "Account", id: "LIST" }],
    }),

    // GET /finance/accounts/{id}
    getAccount: build.query({
      query: (id) => `/master/finance/accounts/${id}`,
      providesTags: (result, error, id) => [{ type: "Account", id }],
    }),

    // POST /finance/accounts
    createAccount: build.mutation({
      query: (body) => ({
        url: `/master/finance/accounts`,
        method: "POST",
        body,
      }),
      invalidatesTags: [{ type: "Account", id: "LIST" }],
    }),

    // PATCH /finance/accounts/{id}
    updateAccount: build.mutation({
      query: ({ id, ...body }) => ({
        url: `/master/finance/accounts/${id}`,
        method: "PATCH",
        body,
      }),
      invalidatesTags: (result, error, { id }) => [
        { type: "Account", id: "LIST" },
        { type: "Account", id },
      ],
    }),

    // DELETE /finance/accounts/{id}
    deleteAccount: build.mutation({
      query: (id) => ({
        url: `/master/finance/accounts/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: (result, error, id) => [
        { type: "Account", id: "LIST" },
        { type: "Account", id },
      ],
    }),
  }),
})

export const {
  useGetAccountsQuery,
  useGetAccountQuery,
  useCreateAccountMutation,
  useUpdateAccountMutation,
  useDeleteAccountMutation,
} = accountsApi
